import { jsx as v, jsxs as K } from "react/jsx-runtime";
import { forwardRef as z, useState as R, useEffect as te, useMemo as D, useCallback as ue, memo as le, useRef as Ce, useImperativeHandle as Xe } from "react";
import { c as F } from "./tw-cn-mXgPecoF.mjs";
import { o as We } from "./index-CcECYkhV.mjs";
import { c as Je } from "./variance-DhhqoHkK.mjs";
import { u as Ye } from "./use-focus-BGKOEgog.mjs";
import { a as De, b as B, r as w, i as L, f as Ze, S as ge } from "./isObjectLike-BurtZzWI.mjs";
var V = Array.isArray, Qe = "[object AsyncFunction]", ke = "[object Function]", et = "[object GeneratorFunction]", tt = "[object Proxy]";
function Re(e) {
  if (!De(e))
    return !1;
  var t = B(e);
  return t == ke || t == et || t == Qe || t == tt;
}
var Z = w["__core-js_shared__"], _e = function() {
  var e = /[^.]+$/.exec(Z && Z.keys && Z.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function rt(e) {
  return !!_e && _e in e;
}
var nt = Function.prototype, at = nt.toString;
function P(e) {
  if (e != null) {
    try {
      return at.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var it = /[\\^$.*+?()[\]{}|]/g, st = /^\[object .+?Constructor\]$/, ot = Function.prototype, ut = Object.prototype, lt = ot.toString, ft = ut.hasOwnProperty, ct = RegExp(
  "^" + lt.call(ft).replace(it, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function dt(e) {
  if (!De(e) || rt(e))
    return !1;
  var t = Re(e) ? ct : st;
  return t.test(P(e));
}
function pt(e, t) {
  return e == null ? void 0 : e[t];
}
function N(e, t) {
  var r = pt(e, t);
  return dt(r) ? r : void 0;
}
var re = N(w, "WeakMap"), gt = 9007199254740991, _t = /^(?:0|[1-9]\d*)$/;
function ht(e, t) {
  var r = typeof e;
  return t = t ?? gt, !!t && (r == "number" || r != "symbol" && _t.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Me(e, t) {
  return e === t || e !== e && t !== t;
}
var yt = 9007199254740991;
function Fe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= yt;
}
function vt(e) {
  return e != null && Fe(e.length) && !Re(e);
}
var bt = Object.prototype;
function mt(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || bt;
  return e === r;
}
function Tt(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var At = "[object Arguments]";
function he(e) {
  return L(e) && B(e) == At;
}
var Le = Object.prototype, xt = Le.hasOwnProperty, wt = Le.propertyIsEnumerable, Ot = he(/* @__PURE__ */ function() {
  return arguments;
}()) ? he : function(e) {
  return L(e) && xt.call(e, "callee") && !wt.call(e, "callee");
};
function St() {
  return !1;
}
var Ge = typeof exports == "object" && exports && !exports.nodeType && exports, ye = Ge && typeof module == "object" && module && !module.nodeType && module, $t = ye && ye.exports === Ge, ve = $t ? w.Buffer : void 0, Pt = ve ? ve.isBuffer : void 0, ne = Pt || St, Et = "[object Arguments]", jt = "[object Array]", Nt = "[object Boolean]", It = "[object Date]", Ct = "[object Error]", Dt = "[object Function]", Rt = "[object Map]", Mt = "[object Number]", Ft = "[object Object]", Lt = "[object RegExp]", Gt = "[object Set]", Ht = "[object String]", zt = "[object WeakMap]", Bt = "[object ArrayBuffer]", Ut = "[object DataView]", Kt = "[object Float32Array]", Vt = "[object Float64Array]", qt = "[object Int8Array]", Xt = "[object Int16Array]", Wt = "[object Int32Array]", Jt = "[object Uint8Array]", Yt = "[object Uint8ClampedArray]", Zt = "[object Uint16Array]", Qt = "[object Uint32Array]", f = {};
f[Kt] = f[Vt] = f[qt] = f[Xt] = f[Wt] = f[Jt] = f[Yt] = f[Zt] = f[Qt] = !0;
f[Et] = f[jt] = f[Bt] = f[Nt] = f[Ut] = f[It] = f[Ct] = f[Dt] = f[Rt] = f[Mt] = f[Ft] = f[Lt] = f[Gt] = f[Ht] = f[zt] = !1;
function kt(e) {
  return L(e) && Fe(e.length) && !!f[B(e)];
}
function er(e) {
  return function(t) {
    return e(t);
  };
}
var He = typeof exports == "object" && exports && !exports.nodeType && exports, M = He && typeof module == "object" && module && !module.nodeType && module, tr = M && M.exports === He, Q = tr && Ze.process, be = function() {
  try {
    var e = M && M.require && M.require("util").types;
    return e || Q && Q.binding && Q.binding("util");
  } catch {
  }
}(), me = be && be.isTypedArray, ze = me ? er(me) : kt, rr = Object.prototype, nr = rr.hasOwnProperty;
function ar(e, t) {
  var r = V(e), n = !r && Ot(e), i = !r && !n && ne(e), a = !r && !n && !i && ze(e), s = r || n || i || a, u = s ? Tt(e.length, String) : [], l = u.length;
  for (var o in e)
    nr.call(e, o) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (o == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (o == "offset" || o == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (o == "buffer" || o == "byteLength" || o == "byteOffset") || // Skip index properties.
    ht(o, l))) && u.push(o);
  return u;
}
function ir(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var sr = ir(Object.keys, Object), or = Object.prototype, ur = or.hasOwnProperty;
function lr(e) {
  if (!mt(e))
    return sr(e);
  var t = [];
  for (var r in Object(e))
    ur.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function fr(e) {
  return vt(e) ? ar(e) : lr(e);
}
var G = N(Object, "create");
function cr() {
  this.__data__ = G ? G(null) : {}, this.size = 0;
}
function dr(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var pr = "__lodash_hash_undefined__", gr = Object.prototype, _r = gr.hasOwnProperty;
function hr(e) {
  var t = this.__data__;
  if (G) {
    var r = t[e];
    return r === pr ? void 0 : r;
  }
  return _r.call(t, e) ? t[e] : void 0;
}
var yr = Object.prototype, vr = yr.hasOwnProperty;
function br(e) {
  var t = this.__data__;
  return G ? t[e] !== void 0 : vr.call(t, e);
}
var mr = "__lodash_hash_undefined__";
function Tr(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = G && t === void 0 ? mr : t, this;
}
function $(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
$.prototype.clear = cr;
$.prototype.delete = dr;
$.prototype.get = hr;
$.prototype.has = br;
$.prototype.set = Tr;
function Ar() {
  this.__data__ = [], this.size = 0;
}
function X(e, t) {
  for (var r = e.length; r--; )
    if (Me(e[r][0], t))
      return r;
  return -1;
}
var xr = Array.prototype, wr = xr.splice;
function Or(e) {
  var t = this.__data__, r = X(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : wr.call(t, r, 1), --this.size, !0;
}
function Sr(e) {
  var t = this.__data__, r = X(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function $r(e) {
  return X(this.__data__, e) > -1;
}
function Pr(e, t) {
  var r = this.__data__, n = X(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function T(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
T.prototype.clear = Ar;
T.prototype.delete = Or;
T.prototype.get = Sr;
T.prototype.has = $r;
T.prototype.set = Pr;
var H = N(w, "Map");
function Er() {
  this.size = 0, this.__data__ = {
    hash: new $(),
    map: new (H || T)(),
    string: new $()
  };
}
function jr(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function W(e, t) {
  var r = e.__data__;
  return jr(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Nr(e) {
  var t = W(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Ir(e) {
  return W(this, e).get(e);
}
function Cr(e) {
  return W(this, e).has(e);
}
function Dr(e, t) {
  var r = W(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function E(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
E.prototype.clear = Er;
E.prototype.delete = Nr;
E.prototype.get = Ir;
E.prototype.has = Cr;
E.prototype.set = Dr;
function Rr(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
function Mr() {
  this.__data__ = new T(), this.size = 0;
}
function Fr(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Lr(e) {
  return this.__data__.get(e);
}
function Gr(e) {
  return this.__data__.has(e);
}
var Hr = 200;
function zr(e, t) {
  var r = this.__data__;
  if (r instanceof T) {
    var n = r.__data__;
    if (!H || n.length < Hr - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new E(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function x(e) {
  var t = this.__data__ = new T(e);
  this.size = t.size;
}
x.prototype.clear = Mr;
x.prototype.delete = Fr;
x.prototype.get = Lr;
x.prototype.has = Gr;
x.prototype.set = zr;
function Br(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, a = []; ++r < n; ) {
    var s = e[r];
    t(s, r, e) && (a[i++] = s);
  }
  return a;
}
function Ur() {
  return [];
}
var Kr = Object.prototype, Vr = Kr.propertyIsEnumerable, Te = Object.getOwnPropertySymbols, qr = Te ? function(e) {
  return e == null ? [] : (e = Object(e), Br(Te(e), function(t) {
    return Vr.call(e, t);
  }));
} : Ur;
function Xr(e, t, r) {
  var n = t(e);
  return V(e) ? n : Rr(n, r(e));
}
function Ae(e) {
  return Xr(e, fr, qr);
}
var ae = N(w, "DataView"), ie = N(w, "Promise"), se = N(w, "Set"), xe = "[object Map]", Wr = "[object Object]", we = "[object Promise]", Oe = "[object Set]", Se = "[object WeakMap]", $e = "[object DataView]", Jr = P(ae), Yr = P(H), Zr = P(ie), Qr = P(se), kr = P(re), A = B;
(ae && A(new ae(new ArrayBuffer(1))) != $e || H && A(new H()) != xe || ie && A(ie.resolve()) != we || se && A(new se()) != Oe || re && A(new re()) != Se) && (A = function(e) {
  var t = B(e), r = t == Wr ? e.constructor : void 0, n = r ? P(r) : "";
  if (n)
    switch (n) {
      case Jr:
        return $e;
      case Yr:
        return xe;
      case Zr:
        return we;
      case Qr:
        return Oe;
      case kr:
        return Se;
    }
  return t;
});
var Pe = w.Uint8Array, en = "__lodash_hash_undefined__";
function tn(e) {
  return this.__data__.set(e, en), this;
}
function rn(e) {
  return this.__data__.has(e);
}
function q(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new E(); ++t < r; )
    this.add(e[t]);
}
q.prototype.add = q.prototype.push = tn;
q.prototype.has = rn;
function nn(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function an(e, t) {
  return e.has(t);
}
var sn = 1, on = 2;
function Be(e, t, r, n, i, a) {
  var s = r & sn, u = e.length, l = t.length;
  if (u != l && !(s && l > u))
    return !1;
  var o = a.get(e), h = a.get(t);
  if (o && h)
    return o == t && h == e;
  var d = -1, c = !0, b = r & on ? new q() : void 0;
  for (a.set(e, t), a.set(t, e); ++d < u; ) {
    var _ = e[d], g = t[d];
    if (n)
      var p = s ? n(g, _, d, t, e, a) : n(_, g, d, e, t, a);
    if (p !== void 0) {
      if (p)
        continue;
      c = !1;
      break;
    }
    if (b) {
      if (!nn(t, function(y, m) {
        if (!an(b, m) && (_ === y || i(_, y, r, n, a)))
          return b.push(m);
      })) {
        c = !1;
        break;
      }
    } else if (!(_ === g || i(_, g, r, n, a))) {
      c = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), c;
}
function un(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
function ln(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var fn = 1, cn = 2, dn = "[object Boolean]", pn = "[object Date]", gn = "[object Error]", _n = "[object Map]", hn = "[object Number]", yn = "[object RegExp]", vn = "[object Set]", bn = "[object String]", mn = "[object Symbol]", Tn = "[object ArrayBuffer]", An = "[object DataView]", Ee = ge ? ge.prototype : void 0, k = Ee ? Ee.valueOf : void 0;
function xn(e, t, r, n, i, a, s) {
  switch (r) {
    case An:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Tn:
      return !(e.byteLength != t.byteLength || !a(new Pe(e), new Pe(t)));
    case dn:
    case pn:
    case hn:
      return Me(+e, +t);
    case gn:
      return e.name == t.name && e.message == t.message;
    case yn:
    case bn:
      return e == t + "";
    case _n:
      var u = un;
    case vn:
      var l = n & fn;
      if (u || (u = ln), e.size != t.size && !l)
        return !1;
      var o = s.get(e);
      if (o)
        return o == t;
      n |= cn, s.set(e, t);
      var h = Be(u(e), u(t), n, i, a, s);
      return s.delete(e), h;
    case mn:
      if (k)
        return k.call(e) == k.call(t);
  }
  return !1;
}
var wn = 1, On = Object.prototype, Sn = On.hasOwnProperty;
function $n(e, t, r, n, i, a) {
  var s = r & wn, u = Ae(e), l = u.length, o = Ae(t), h = o.length;
  if (l != h && !s)
    return !1;
  for (var d = l; d--; ) {
    var c = u[d];
    if (!(s ? c in t : Sn.call(t, c)))
      return !1;
  }
  var b = a.get(e), _ = a.get(t);
  if (b && _)
    return b == t && _ == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var p = s; ++d < l; ) {
    c = u[d];
    var y = e[c], m = t[c];
    if (n)
      var I = s ? n(m, y, c, t, e, a) : n(y, m, c, e, t, a);
    if (!(I === void 0 ? y === m || i(y, m, r, n, a) : I)) {
      g = !1;
      break;
    }
    p || (p = c == "constructor");
  }
  if (g && !p) {
    var j = e.constructor, O = t.constructor;
    j != O && "constructor" in e && "constructor" in t && !(typeof j == "function" && j instanceof j && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var Pn = 1, je = "[object Arguments]", Ne = "[object Array]", U = "[object Object]", En = Object.prototype, Ie = En.hasOwnProperty;
function jn(e, t, r, n, i, a) {
  var s = V(e), u = V(t), l = s ? Ne : A(e), o = u ? Ne : A(t);
  l = l == je ? U : l, o = o == je ? U : o;
  var h = l == U, d = o == U, c = l == o;
  if (c && ne(e)) {
    if (!ne(t))
      return !1;
    s = !0, h = !1;
  }
  if (c && !h)
    return a || (a = new x()), s || ze(e) ? Be(e, t, r, n, i, a) : xn(e, t, l, r, n, i, a);
  if (!(r & Pn)) {
    var b = h && Ie.call(e, "__wrapped__"), _ = d && Ie.call(t, "__wrapped__");
    if (b || _) {
      var g = b ? e.value() : e, p = _ ? t.value() : t;
      return a || (a = new x()), i(g, p, r, n, a);
    }
  }
  return c ? (a || (a = new x()), $n(e, t, r, n, i, a)) : !1;
}
function Ue(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !L(e) && !L(t) ? e !== e && t !== t : jn(e, t, r, n, Ue, i);
}
function Nn(e, t) {
  return Ue(e, t);
}
const In = Je(
  [
    "max-h-[340px] block min-h-72 w-full resize-none overflow-y-auto placeholder:text-text-neutral-medium text-text-neutral-main disabled:text-interaction-neutral-disable-main disabled:placeholder:text-interaction-neutral-disable-main disabled:bg-fill-neutral-weak typography-body-14-regular-multiline border border-solid relative border-line-neutral-weak3 rounded-12 px-16 py-12"
  ],
  {
    variants: {
      isFocused: {
        true: "border px-15 py-11",
        false: ""
      },
      disabled: {
        true: "bg-fill-neutral-weak",
        false: "bg-static-white"
      }
    },
    defaultVariants: {
      isFocused: !1,
      disabled: !1
    }
  }
), oe = 340, Cn = 21, Dn = 24, Rn = (e) => {
  const t = Math.min(e, oe) - Dn;
  return Math.floor(t / Cn);
}, fe = z(
  ({ maxHeight: e = oe, disabled: t, hasError: r, defaultValue: n, maxLength: i, id: a, value: s, onChange: u, ...l }, o) => {
    e > oe && process.env.NODE_ENV === "development" && console.warn("maxHeight: maxHeight must be less than or equal to 340.");
    const [h, d] = R(null);
    te(() => {
      import("./react-textarea-autosize.browser.esm-B2yGxKRM.mjs").then((S) => {
        d(() => S.default);
      });
    }, []);
    const [c, b] = R(null), _ = D(() => ({ current: c }), [c]), { isFocused: g } = Ye(_), p = s !== void 0, [y, m] = R(n || ""), I = p ? s : y, j = D(() => Math.max(1, Rn(e)), [e]), O = D(() => t ? "border-line-neutral-weak3" : r ? "border-line-danger-main caret-text-danger-main" : g ? "border-line-primary-main caret-fill-primary-main" : "border-line-neutral-weak3", [t, r, g]), ce = In({ isFocused: g, disabled: t }), de = D(() => We([
      (S) => {
        b(S);
      },
      o
    ]), [o]), pe = ue(
      (S) => {
        let { value: C } = S.target;
        i && C.length > i && (C = C.slice(0, i), S.target.value = C), p || m(C), u == null || u(S);
      },
      [p, i, u]
    );
    return te(() => {
      p && m(I);
    }, [p, I]), h ? /* @__PURE__ */ v(
      h,
      {
        className: F(ce, O),
        defaultValue: p ? void 0 : n,
        disabled: t,
        id: a,
        maxLength: i,
        maxRows: j,
        name: "textField",
        onChange: pe,
        ref: de,
        value: p ? s : y,
        ...l
      }
    ) : /* @__PURE__ */ v(
      "textarea",
      {
        className: F(ce, O),
        defaultValue: p ? void 0 : n,
        disabled: t,
        id: a,
        maxLength: i,
        name: "textField",
        onChange: pe,
        ref: de,
        value: p ? s : y,
        ...l
      }
    );
  }
);
fe.displayName = "NDS.BaseTextArea";
const J = z(({ children: e, ...t }, r) => /* @__PURE__ */ v("label", { ref: r, ...t, className: "flex-start flex w-full px-4", children: typeof e == "string" ? /* @__PURE__ */ v("span", { className: "line-clamp-1 text-text-neutral-main typography-body-13-semibold", children: e }) : e }));
J.displayName = "NDS.Label";
le(J, Nn);
const Y = ({
  leftContent: e,
  leftContentClassName: t,
  currentLength: r,
  maxLength: n,
  hasError: i,
  disabled: a
}) => {
  const s = D(() => a ? "text-interaction-neutral-disable-main" : i ? "text-text-danger-main" : "text-text-neutral-main", [a, i]);
  return /* @__PURE__ */ K("div", { className: "flex w-full justify-between px-4 text-left", children: [
    e ? /* @__PURE__ */ v("div", { className: F("mr-8 line-clamp-2 typography-body-12-regular", s, t), children: e }) : null,
    !a && n !== void 0 && r !== void 0 ? /* @__PURE__ */ K("div", { className: "ml-auto typography-body-12-regular", children: [
      /* @__PURE__ */ v("span", { className: "font-bold", children: r.toLocaleString() }),
      "/",
      n.toLocaleString()
    ] }) : null
  ] });
};
Y.displayName = "NDS.SupportText";
le(Y);
const Ke = z(
  ({ label: e, supportLeftContent: t, onChange: r, className: n, textAreaRef: i, ...a }, s) => {
    const u = Ce(null);
    Xe(s, () => u.current);
    const l = ue(
      (o) => {
        r == null || r(o);
      },
      [r]
    );
    return /* @__PURE__ */ K("div", { className: F("flex w-full flex-col gap-8", n), ref: u, children: [
      e ? /* @__PURE__ */ v(J, { htmlFor: a.id, children: e }) : null,
      /* @__PURE__ */ v(fe, { onChange: l, ref: i, ...a }),
      t ? /* @__PURE__ */ v(Y, { disabled: a.disabled, hasError: a.hasError, leftContent: t }) : null
    ] });
  }
);
Ke.displayName = "NDS.DefaultTextArea";
const ee = (e) => typeof e == "string" ? e : typeof e == "number" ? e.toString() : Array.isArray(e) ? e.join(",") : "", Ve = z(
  ({ label: e, supportLeftContent: t, maxLength: r, value: n, defaultValue: i, onChange: a, className: s, textAreaRef: u, ...l }, o) => {
    const h = Ce(null), d = n !== void 0, [c, b] = R(ee(n ?? i ?? "")), [_, g] = R(c.length), p = ue(
      (y) => {
        const { value: m } = y.target;
        d || b(m), a == null || a(y), g(m.length);
      },
      [a, d]
    );
    return te(() => {
      d && g(ee(n).length);
    }, [d, n]), /* @__PURE__ */ K("div", { className: F("flex w-full flex-col gap-8", s), ref: h, children: [
      e ? /* @__PURE__ */ v(J, { htmlFor: l.id, children: e }) : null,
      /* @__PURE__ */ v(
        fe,
        {
          defaultValue: d ? void 0 : i,
          maxLength: r,
          onChange: p,
          ref: u,
          value: d ? ee(n) : void 0,
          ...l
        }
      ),
      /* @__PURE__ */ v(
        Y,
        {
          currentLength: _,
          disabled: l.disabled,
          hasError: l.hasError,
          leftContent: t,
          maxLength: r
        }
      )
    ] });
  }
);
Ve.displayName = "NDS.NeedsCharCountTextArea";
const qe = z(({ maxLength: e, ...t }, r) => e === void 0 ? /* @__PURE__ */ v(Ke, { ref: r, ...t }) : /* @__PURE__ */ v(Ve, { maxLength: e, ref: r, ...t }));
qe.displayName = "NDS.TextArea";
le(qe);
export {
  qe as T
};
